<template>
  <div>
    <el-dialog
      :title="dialogOption.title"
      :visible.sync="dialogOption.dialogVisible"
      :before-close="close"
      :close-on-click-modal="false"
      destroy-on-close
      width="600px"
    >
      <div class="label-m">
        <div v-show="showData.locationNo">
          <span class="no">库号：</span>{{ showData.locationNo }}
          <span class="name">库位名称：</span>{{ showData.label }}
        </div>
      </div>
      <el-tree
        accordion
        :data="treeData"
        :props="defaultProps"
        @node-click="handleNodeClick"
      ></el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close" size="small">{{
          $l("INDEX.btn_cancel") || "取消"
        }}</el-button>
        <el-button type="primary" @click="save" size="small">{{
          $l("INDEX.btn_save") || "保存"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    treeData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogOption: {
        title: this.$l("dialog_title") || "库位设置",
        dialogVisible: false,
      },
      showData: {},
      params: {
        fabricStockCode: "",
        locationNo: "",
      },
      defaultProps: { children: "children", label: "label" },
    };
  },
  methods: {
    load(code) {
      this.showData = {};
      this.params = {};
      this.params.fabricStockCode = code;
      this.dialogOption.dialogVisible = true;
    },
    handleNodeClick(data) {
      this.showData = data;
      this.params.level = data.level;
      this.params.locationNo = data.locationNo;
    },
    save() {
      if (!this.params.level) {
        this.$message.warning(
          this.$l("tips_warning_select") || "请选择一个库位"
        );
        return;
      }
      if (this.params.level === "0") {
        this.$message.warning(
          this.$l("dialog_confirm_msg") || "不可将顶级展厅设置为库位！"
        );
        return;
      }
      this.$confirm(
        this.$l("dialog_confirm_tips") + `【${this.showData.label}】?` ||
          `是否设置该【${this.showData.label}】库位？`,
        this.$l("INDEX.tips_question_title") || "提示",
        {
          confirmButtonText: this.$l("INDEX.tips_confirm") || "确认",
          cancelButtonText: this.$l("INDEX.tips_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.$api.fabricStockSetStorageApi(this.params).then(() => {
            this.$message.success(this.$l("tips_set_ok") || "设置成功！");
            this.$emit("refresh");
            this.close();
          });
        })
        .catch(() => {});
    },
    close() {
      this.dialogOption.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss">
.label-m {
  margin: 10px 9px;
  font-size: 17px;
}
.el-dialog__body {
  padding: 15px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.no {
  width: 55px;
  padding: 2px;
  box-sizing: border-box;
  background: #e8e6e6;
  border-radius: 4px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
}
.name {
  width: 100px;
  padding: 2px;
  box-sizing: border-box;
  background: #e8e6e6;
  border-radius: 4px;
  display: inline-block;
  text-align: center;
  margin-right: 6px;
  margin-left: 10px;
}
</style>
